import type { UnitOfMeasureResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toUnitOfMeasure } from './toUnitOfMeasure';

// Builds a normalized `Data.UnitOfMeasure` domain from a list of DTOs.
function toUnitOfMeasureDomain(args: { dtos: UnitOfMeasureResponse[] }) {
  const { dtos } = args;

  const unitOfMeasureDomain: NormalizedDomain<Data.UnitOfMeasure> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const unitOfMeasure = toUnitOfMeasure(item);
      domainUtility.mutateAdd(unitOfMeasureDomain, unitOfMeasure);
    },
  });

  return { unitOfMeasureDomain };
}

export { toUnitOfMeasureDomain };
